export interface DateRangeResult {
  from: Date
  to: Date
}

export const formatReadingsDate = (date: Date | null | undefined) =>
  date
    ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
    : undefined

export const getDefaultRange = (
  intervalMonths = 0,
  intervalDays = 0,
  referenceDate = new Date()
): DateRangeResult => {
  const to = new Date(referenceDate)
  const from = new Date(to)
  from.setMonth(from.getMonth() - intervalMonths)
  from.setDate(from.getDate() - intervalDays)
  return { from, to }
}

/**
 * Calculates the default 1-year date range ending on the 15th of the previous month.
 *
 * Example:
 * If today is 04/08/2026 (August 4, 2026):
 * to: 15/07/2026 (July 15, 2026)
 * from: 15/07/2025 (July 15, 2025)
 *
 * If today is 15/01/2027 (January 15, 2027):
 * to: 15/12/2026 (December 15, 2026)
 * from: 15/12/2025 (December 15, 2025)
 */
export const getDefaultFifteenthDateRange = (
  intervalYears = 1,
  referenceDate = new Date()
): DateRangeResult => {
  const currentYear = referenceDate.getFullYear()
  const currentMonth = referenceDate.getMonth() // 0-based: 0 = Jan, 7 = Aug

  // 15th of the previous month
  const to = new Date(currentYear, currentMonth - 1, 15, 0, 0, 0, 0)
  // Exactly intervalYears year prior to 'to'
  const from = new Date(to.getFullYear() - intervalYears, to.getMonth(), 15, 0, 0, 0, 0)

  return { from, to }
}
